module.exports = __webpack_public_path__ + "static/media/Leccion-3-19-Cuidando-mi-Actitud-y-Prioridades-I.114686c6.pdf";